/* eslint-disable */

"use client";
import React, { useState, useEffect } from "react";
import HeroSection from "./hero-section";
import OverviewSection from "./overview-section";
import HeighLight from "./heighlight";
import AboutSection from "./about-hotel";
import OffersAndPackages from "./offer-package";
import PricingSection from "./pricing";
import CapacitySection from "./capacity";
import PlaceOffers from "./place-offers";
import EventType from "./event-type";
import SpecifyEvent from "./SpecifyEvent";
import { FaMapMarkerAlt, FaRegMap } from "react-icons/fa";
import { CiShare2 } from "react-icons/ci";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import Map from "./map";
import RatingsAndReviews from "../venueStayPreview/ratingsAndReviews";
import { useSelector, useDispatch } from "react-redux";
import NewFavoriteFolderModal from "../myFav/NewFavoriteFolderModal";
import AddedFavoriteModal from "../myFav/AddedFavoriteModal";
import { toast } from "react-toastify";
import SocialMediaModal from "../myFav/SocialMediaModal";
import { DeviceType } from "../../hooks/deviceType";
import { base_URL } from "../../config/config";
import axios from "axios";
import { setUser } from "../../store/features/authSlice";
import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../lib/apis";
import HotelChildCards from "../venueStayPreview/HotelChildCards";
import Modal from "../shared/custom-modal/custom-modal";
import UserLogin from "../../pages/onboarding/user-login";
import LoginModal from "../shared/custom-modal/login-modal";
import EnquirySuccessfulModel from "./EnquirySuccessfulModel";

const VenuePreview = ({ data, breadcrumbPath, childcards = [] }) => {
	const dispatch = useDispatch();
	const deviceType = DeviceType();
	const user = useSelector((state) => state.auth.user);
	const favoriteVenues =
		user?.favoritesFolder?.map((folder) => folder.venues).flat() || [];
	const [newFolder, setNewFolder] = useState(false);
	const [favItem, setFavItem] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalAddedOpen, setIsModalAddedOpen] = useState(false);
	const [shareModal, setShareModal] = useState(false);
	const [totalActiveTime, setTotalActiveTime] = useState(0);

	// >>> ADDED FOR MOBILE ENQUIRY BUTTON <<<
	const [showMobileEnquiry, setShowMobileEnquiry] = useState(false);
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [showEnquiryModal, setShowEnquiryModal] = useState(false);
	// >>> END <<<

	const locationDetails = data?.location;
	const isFavorite =
		data && favoriteVenues?.some((favorite) => favorite?.id === data?._id);

	let lastActive = Date.now();
	let activeTime = 0;
	const updateActiveTime = () => {
		if (document.visibilityState === "hidden") {
			// User leaves the page
			activeTime += Date.now() - lastActive;
			// console.log(
			//   "Total active time (seconds):",
			//   (activeTime / 1000).toFixed(2)
			// );
			// console.log("Last active (timestamp):", new Date(lastActive));
			// console.log(
			//   "Active time (seconds):",
			//   ((Date.now() - lastActive) / 1000).toFixed(2)
			// );
			// console.log("Device type:", deviceType);
			const time = ((Date.now() - lastActive) / 1000).toFixed(2);
			updateActiveTimeAPI(time);
		} else if (document.visibilityState === "visible") {
			// User returns to the page
			lastActive = Date.now();
		}
	};

	const getFavoriteFolder = async () => {
		try {
			const response = await fetch(
				`${base_URL}/api/auth/get-folders/${user?._id}`
			);
			if (!response.ok) {
				console.log("Failed to fetch Venues");
				return;
			}
			const data = await response.json();
			refetchFav1();
			return data.folders;
		} catch (err) {
			console.log(err);
		}
	};
	const { folders, refetch } = useQuery({
		queryKey: ["favoriteFolder", user?._id],
		queryFn: getFavoriteFolder,
		enabled: !!user?._id, // Ensure the query only runs when these values are available
	});

	// Attach visibility change listener once
	useEffect(() => {
		// console.log("Venue data:", data);
		const handleVisibilityChange = () => updateActiveTime();
		document.addEventListener("visibilitychange", handleVisibilityChange);

		return () => {
			// Final calculation before cleanup
			activeTime += Date.now() - lastActive;
			// const totalTime = (Date.now() - startTime) / 1000;
			const totalActiveInSeconds = activeTime / 1000;

			// console.log(`Time spent on venue ${data?._id}:`);
			// console.log(`- Total time (active + inactive): ${totalTime} seconds`);
			// console.log(`- Active time: ${totalActiveInSeconds} seconds`);

			// Optionally update the state or send analytics here
			setTotalActiveTime(totalActiveInSeconds);

			document.removeEventListener("visibilitychange", handleVisibilityChange);
		};
	}, [data?._id, user?._id, deviceType]);
	const updateActiveTimeAPI = async (time) => {
		// const time = totalActiveTime;
		try {
			await axios.post(`${base_URL}/api/impressions/update-impressions`, {
				venueId: data?._id,
				venueName: `${data?.basicDetails?.venueName}, ${data?.basicDetails?.hotelName}`,
				pageVisitTime: time,
				customerId: user?._id || "anonymous",
				vendorId: data?.vendorId,
				deviceCategory: deviceType,
				date: new Date().toISOString().split("T")[0],
			});

			// console.log("API response:", response.data);
			// toast.success("Active time updated successfully!");
		} catch (error) {
			console.error("Error updating active time:", error);
			// toast.error("Failed to update active time.");
		}
	};

	useEffect(() => {
		getUserInfo();
	}, []);

	const getUserInfo = async () => {
		const userInfo = await getUser(user?._id);
		let venuesAndStay = [];
		userInfo?.favoritesFolder?.forEach((folder) => {
			if (folder.venues.length > 0) {
				venuesAndStay = [...venuesAndStay, ...folder?.venues];
			}
		});
		// console.log(userInfo);
		return venuesAndStay;
	};
	const { data: userFavorites, refetch: refetchFav1 } = useQuery({
		queryKey: ["userFavorites1"],
		queryFn: getUserInfo,
		enabled: !!user?._id,
	});

	// handling add/remove favorite
	const handleClickFavorite = async (itemId) => {
		if (!itemId) return;

		if (!user) {
			return toast.error("Please login first");
		}

		const isFavorited =
			userFavorites &&
			userFavorites.find((favorite) => favorite?.id === itemId);

		if (isFavorited) {
			refetch();
			refetchFav1();
			// If already favorited, remove it
			await removeFavorite(itemId);
		} else {
			// If not favorited, add it
			refetch();
			refetchFav1();
			setFavItem(itemId);
			user?.favoritesFolder?.length > 0
				? setIsModalAddedOpen(true)
				: setIsModalOpen(true);
		}
	};

	// remove favorite
	const removeFavorite = async (itemId) => {
		try {
			const response = await axios.post(
				`${base_URL}/api/favorite/remove-favorite`,
				{
					userId: user._id,
					itemId,
				}
			);

			if (response?.data?.success) {
				toast.success("Removed from favorites");
				refetchFav1();
				refetch();
			} else {
				toast.error("Failed to remove from favorites");
			}
		} catch (error) {
			console.error(error);
			toast.error("An error occurred while removing from favorites");
		}
	};

	const handleMobileEnquiryClick = () => {
		if (!user) {
			// user not logged in → show login modal
			setShowLoginModal(true);
			return;
		}
		// user logged in → show enquiry bottom sheet
		setShowMobileEnquiry(true);
	};

	const videos1 = data?.imagesAndVideos?.videos || [];
	const videos2 = data?.imagesAndVideos?.videoLinks || [];
	const allVideos = [...videos1, ...videos2];
	return (
		<>
			{newFolder && (
				<NewFavoriteFolderModal
					isOpen={newFolder}
					onClose={() => {
						setNewFolder(false);
						refetchFav1();
					}}
					itemId={favItem}
					type={"venue"}
					refetch={refetch}
				/>
			)}
			{user?.favoritesFolder.length > 0 ? (
				<AddedFavoriteModal
					setNewFolder={setNewFolder}
					isOpen={isModalAddedOpen}
					itemId={favItem}
					refetch={refetch}
					data={user?.favoritesFolder}
					type={"venue"}
					onClose={() => {
						setIsModalAddedOpen(false);
						refetchFav1();
					}}
				/>
			) : (
				<NewFavoriteFolderModal
					isOpen={isModalOpen}
					itemId={favItem}
					refetch={refetch}
					type={"venue"}
					onClose={() => {
						setIsModalOpen(false);
						refetchFav1();
					}}
				/>
			)}
			<HeroSection
				data={data?.imagesAndVideos?.images}
				videos={allVideos}
				basicInfo={data?.basicDetails}
				breadcrumbPath={breadcrumbPath}
			/>
			{shareModal && (
				<SocialMediaModal
					isOpen={shareModal}
					onClose={() => setShareModal(false)}
					shareLink={window.location.href}
				/>
			)}
			<div className="md:flex justify-between items-start  w-full  lg:px-[57px] px-6 ">
				<div className="flex flex-col mb-4">
					{data?.basicDetails?.venueName ? (
						<h2 className="text-[32px] font-bold flex gap-4 items-center">
							{data?.basicDetails?.venueName}, {data?.basicDetails?.hotelName}
						</h2>
					) : (
						<h2 className="text-[32px] font-[500] text-black flex gap-4 items-center ">
							Venue Name
						</h2>
					)}

					<div className="black flex gap-2 items-center mb-4">
						<FaMapMarkerAlt className="inline mr-2" />
						<span className="font-medium underline decoration-2 underline-offset-2">
							{locationDetails?.city && locationDetails?.area
								? `${locationDetails?.city}, ${locationDetails?.area}`
								: "Location Not Available"}
						</span>

						<a
							href="#map"
							className="text-blue-500 flex ml-1 font-semibold gap-2 items-center"
						>
							<FaRegMap className="text-[#FE4747]" />
							<span className="underline underline-offset-2 decoration-2 text-[#FE4747]">
								Show on map
							</span>
						</a>
					</div>
				</div>
				<div className="flex justify-between items-center gap-4">
					<div
						className="flex justify-center cursor-pointer items-center gap-2 border border-black px-6 py-4 rounded-[8px]"
						onClick={() => setShareModal(true)}
					>
						<CiShare2 className="text-black text-2xl" />
						Share
					</div>
					<div
						className="flex justify-center items-center gap-2 border border-black px-6 py-4 rounded-[8px] cursor-pointer"
						onClick={() => {
							handleClickFavorite(data?._id);
						}}
					>
						{userFavorites &&
						userFavorites?.find((favorite) => favorite?.id === data?._id) ? (
							<IoMdHeart className="text-primary text-2xl" />
						) : (
							<IoMdHeartEmpty className="text-primary text-2xl" />
						)}
						Favourite
					</div>
				</div>
			</div>
			<div className="md:flex justify-between items-start  w-full  lg:px-[57px] px-6 mt-2">
				<div className="md:w-[68%] w-full">
					<OverviewSection data={data} locationDetails={data?.location} />
					<HeighLight data={data} />
					<AboutSection data={data} />
					<OffersAndPackages data={data?.offersAndPackages} />
					<PricingSection data={data?.pricing} />
					<CapacitySection
						data={data?.capacity}
						UploadDocuments={data?.UploadDocuments}
					/>
					<PlaceOffers data={data} UploadDocuments={data?.UploadDocuments} />
					<EventType data={data} />
					{childcards?.length >= 1 && (
						<HotelChildCards
							data={childcards}
							hasMore={false}
							isLoading={false}
							onLoadMore={() => {}}
							showLess={() => {}}
							breadcrumbPath={breadcrumbPath}
							showLessText={false}
						/>
					)}
					<Map venue={data} />
				</div>

				{/* OLD SPECIFY-EVENT – HIDDEN ON MOBILE */}
				<div className="md:w-[30%] w-full hidden md:block">
					<SpecifyEvent
						type="venue"
						data={data}
						onSuccess={() => {
							setShowMobileEnquiry(false);
						}}
					/>
				</div>
			</div>

			{/* Floating Button */}
			<div className="fixed bottom-0 left-0 w-full bg-white p-4 shadow-md md:hidden">
				<button
					className="w-full bg-red-500 text-white text-lg font-semibold py-3 rounded-md"
					onClick={handleMobileEnquiryClick}
				>
					Enquire Now
				</button>
			</div>

			{/* Bottom Sheet */}
			{showMobileEnquiry && (
				<div className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden flex items-end">
					<div className="bg-white w-full rounded-t-2xl p-4 max-h-[80vh] overflow-y-auto animate-slide-up">
						<div className="flex justify-end">
							<button
								onClick={() => setShowMobileEnquiry(false)}
								className="text-2xl font-bold text-gray-600"
							>
								✕
							</button>
						</div>

						{/* SPECIFY EVENT INSIDE MOBILE SIDEBAR */}
						<SpecifyEvent
							type="venue"
							data={data}
							onSuccess={() => {
								setShowMobileEnquiry(false);
								setShowEnquiryModal(true);
							}}
						/>
					</div>
				</div>
			)}
			{showLoginModal && (
				<LoginModal
					isOpen={showLoginModal}
					onClose={() => setShowLoginModal(false)}
				/>
			)}
			{showEnquiryModal && (
				<EnquirySuccessfulModel
					isOpen={showEnquiryModal}
					setIsOpen={setShowEnquiryModal}
				/>
			)}
		</>
	);
};

export default VenuePreview;
